// WhatsApp próprio do "Anuncie seu imóvel", diferente do tel1 do site. Pedido de um cliente
// só = gate por codsite: quem não está aqui continua no tel1, como antes. Os outros botões
// de WhatsApp do site (topo, flutuante, cards de busca/financiamento) não mudam.
// Número só com dígitos e com o DDI.
const ANUNCIE_WHATSAPP_POR_SITE: Record<number, string> = {
    2636: '5511947510113', // Almar Imóveis (Daniel, 16/09)
};

export const anuncieWhatsAppDoSite = (site: any): string | null =>
    ANUNCIE_WHATSAPP_POR_SITE[Number(site?.id)] ?? null;
